<template>
  <LoginBaseTemplate :title="pageTitle">
    <label class="mb-2 block">{{ $t("email") }}</label>
    <input
      v-model.trim="credentials.email"
      type="text"
      class="p-2 mb-2 md:p-3 sm:mb-5"
      @keyup.enter="login()"
    />
    <label class="mb-2 block">{{ $t("password") }}</label>
    <Password
      v-model.trim="credentials.password"
      toggle-mask
      class="mb-2 sm:mb-5 w-full"
      :feedback="false"
      @keyup.enter="login()"
    />
    <button
      type="button"
      class="p-button p-component justify-content-center"
      @click="login()"
    >
      {{ $t("enter") }}
    </button>
    <InlineMessage v-if="messageError" severity="error">
      {{ $t(messageError) }}
    </InlineMessage>
    <ProgressBar v-if="isLoading" mode="indeterminate" />
    <p class="message text-sm text-center">
      <a @click="goToAccountRecovery">{{ $t("i_forgot_access_data") }}</a>
    </p>
  </LoginBaseTemplate>
</template>

<script>
import Password from "primevue/password";
import InlineMessage from "primevue/inlinemessage";
import LoginBaseTemplate from "./LoginBaseTemplate.vue";

export default {
  components: { LoginBaseTemplate, InlineMessage, Password },
  extends: LoginBaseTemplate,
  data() {
    return {
      credentials: {
        email: "",
        password: "",
      },
      messageError: null,
      isLoading: false,
    };
  },
  computed: {
    pageTitle() {
      return this.$isParcialFinance()
        ? this.$t("client_parcialfinance")
        : this.$isBalcaoMais()
        ? this.$t("client_area_mais")
        : this.$t("client_area");
    },
  },
  methods: {
    decodeJwtPayload(token) {
      try {
        const base64Url = token.split(".")[1] || "";
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const paddedBase64 = base64.padEnd(
          base64.length + ((4 - (base64.length % 4)) % 4),
          "="
        );
        return JSON.parse(atob(paddedBase64));
      } catch (e) {
        return null;
      }
    },
    login() {
      if (!this.credentials.email || !this.credentials.password) {
        this.messageError = "email_or_password_is_required";
        return;
      }
      this.messageError = null;
      this.isLoading = true;
      this.$root.axiosSetAuth(null, false);
      this.$root
        .apiPostUnauthenticated(this.$root.api.login, this.credentials)
        .then((response) => {
          this.$store.commit("setToken", response.data.data);
          this.$root.axiosSetAuth(response.data.data, false);
          const payload = this.decodeJwtPayload(response.data.data);
          if (payload) {
            this.$store.commit("setAllowedModules", payload.roles);
            this.$store.commit("setHasBalcaoMais", payload.hasBalcaoMais);
            this.$store.commit(
              "setPendingClientRgpdToken",
              payload.pendingClientRgpdToken
            );
          }
          this.isLoading = false;

          const urlParams = new URLSearchParams(window.location.search);
          const next = urlParams.get("next");
          if (this.$isBalcaoMais()) {
            document.title = this.pageTitle + " - Balcão Mais";
          } else if (this.$isParcialFinance()) {
            document.title = this.pageTitle + " - ParcialFinance";
          } else {
            document.title = this.pageTitle + " - Balcão do Emigrante";
          }

          const firstAccessQuery = {
            source: "Email",
            medium: "E-mail",
            campaign: "firstAccess",
          };
          const isFirstAccess = Boolean(response.data.was_first_access);
          if (
            isFirstAccess &&
            typeof window !== "undefined" &&
            window.dataLayer &&
            Array.isArray(window.dataLayer)
          ) {
            window.dataLayer.push({
              event: "first_access_campaign",
              ...firstAccessQuery,
            });
          }

          if (next && next !== "/") {
            this.$router
              .push(
                isFirstAccess ? { path: next, query: firstAccessQuery } : next
              )
              .catch(() => {});
          } else {
            this.$router
              .push(
                isFirstAccess
                  ? { name: "dashboard", query: firstAccessQuery }
                  : { name: "dashboard" }
              )
              .catch(() => {});
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.messageError = error.response.data.msg_code;
          if (this.messageError == "rgpd_is_required") {
            let params = { email: this.credentials.email };
            this.$root
              .apiGet(this.$root.api.loginRgpd, { params })
              .then((response) => {
                if (response.data.data.token) {
                  this.$router
                    .push({
                      name: "rgpd",
                      params: { token: response.data.data.token },
                    })
                    .catch(() => {});
                }
              });
          }
        });
    },
    goToAccountRecovery() {
      this.$router.push({ name: "account-recovery" }).catch(() => {});
    },
  },
};
</script>
